import { Row, Col, Card } from "antd";
import { useDispatch } from "react-redux";
import DynoStatisticsTable from "./Table";
import { getApis } from "components/Common/apis";
import { useCallback, useEffect, useState } from "react";
import { vehicleDynoStatisticsApiUrl } from "components/Common/endpoints";
import BarChartStatistics from "./BarChart";
import { setPageLoader } from "reducers/loaderSlice";

const Dyno = () => {
  const dispatch = useDispatch();
  const [dynoTestPassData, setDynoTestPassData] = useState({
    List: [],
    modeList: [],
    modelList: [],
  });
  const authToken = localStorage.getItem("authToken");

  const getDynoStatisticDetails = useCallback(
    async () => {
      await getApis(vehicleDynoStatisticsApiUrl, {}, authToken)
        .then((res) => {
          let modeList = [];
          let modelList = Object.keys(res?.data);
          const tableData = Object.entries(res?.data).reduce(
            (acc, [model, driveModes], firstIndex) => {
              const formattedModel = driveModes.reduce(
                (modelAcc, { driveMode, passPercentage }, index) => {
                  modeList.push(driveMode);
                  modelAcc["key"] = "" + firstIndex + index;
                  modelAcc[driveMode] = passPercentage;
                  return modelAcc;
                },
                { model }
              );

              acc.push(formattedModel);
              return acc;
            },
            []
          );

          setDynoTestPassData({
            List: tableData,
            modeList: [...new Set(modeList)],
            modelList,
          });
        })
        .catch((e) => console.log(e));
      dispatch(setPageLoader(null));
    },
    // eslint-disable-next-line
    [authToken]
  );

  useEffect(() => {
    dispatch(setPageLoader("refresh"));
    getDynoStatisticDetails();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDynoStatisticDetails]);

  return (
    <Row
      gutter={{
        xs: 8,
        sm: 16,
        md: 24,
      }}
      data-testid="dyno-statistics"
    >
      <Col xs={24} sm={24} md={12} lg={12} xl={12} id="dyno-history-one">
        <Card title="Dyno Test: Target Speed Match Percentage" className="h100">
          <DynoStatisticsTable tableData={dynoTestPassData} />
        </Card>
      </Col>
      <Col xs={24} sm={24} md={12} lg={12} xl={12} id="dyno-history-one">
        <Card title="Dyno Test">
          <BarChartStatistics dynoTestPassData={dynoTestPassData} />
        </Card>
      </Col>
    </Row>
  );
};

export default Dyno;
